<template>
	<div>
		<Toptab/>
		<div class="new">
			<div class="newtitle">
				<h6>{{this.new.title}}</h6>
				<p class="append"> 来源:<span>{{this.new.from}}</span> 时间：<span>{{this.new.time}}</span></p>
		
			</div>
			<div class="text-new">
				<p>{{this.new.text1}}</p>
				<img :src="this.new.img" >
				<p>{{this.new.text2}}</p>
			</div>
		</div>
		<Footbar/>
		
	</div>
</template>

<script>
</script>

<script>
	import Toptab from '../components/toptab.vue'
	import Footbar from "../components/footbar.vue"
	export default {
		components: {
			Toptab,
			Footbar
		},
		data(){
			return {
				id:-1,
				new:{
					title:"商务部确定：四俩三岔路口撒出教室里凑得出来滴",
					from:"新闻网",
					time:"2021-8-20",
					text1:"商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔",
					img:require("../assets/img/bg.png"),
					text2:"商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔路口撒出教室里凑得出来滴商务部确定：四俩三岔"
					
				}
			}
		},
		created() {
			 this.id = this.$route.params.id
			 // $.post("test.php", { "id": this.id },
			 //    function(data){
			     
			 //      console.log(data); //  2pm
			 //    }, "json");
		}
	}
</script>

<style scoped>
	@import url("../assets/css/commen.css");
	@import url("../assets/css/new.css");
	
</style>
